import { useContext } from 'react';

import PageContext from '@/Providers/PageContextProvider/PageContext';
import CowcamoTextLink from '@/components/CowcamoTextLink';
import { EXTERNAL_CONFIRMATION_RESEND_PATH } from '@/constants/external-pages';
import { getSiteOrigin } from '@/utils/site-origin';

type Props = {
  readonly className?: string;
};

/**
 * A link to the cowcamo-rails page for re-sending the sign-up confirmation email. Users whose
 * address is still unconfirmed cannot sign in here, and confirmation is handled by cowcamo-rails
 * (Devise), so the sign-in form points them at that page. Renders nothing when the site origin
 * is unknown.
 *
 * Kept as a cowcamo-owned component (with the label hardcoded — cowcamo is Japanese-only) so the
 * link lives outside upstream files: it keeps this cowcamo-specific string out of the shared
 * phrases and shrinks the touch on upstream forms to a single line, avoiding merge churn on
 * upstream syncs.
 */
const CowcamoConfirmationResendLink = ({ className }: Props) => {
  const { experienceSettings } = useContext(PageContext);
  const siteOrigin = getSiteOrigin(experienceSettings);

  if (!siteOrigin) {
    return null;
  }

  return (
    <CowcamoTextLink
      className={className}
      href={new URL(EXTERNAL_CONFIRMATION_RESEND_PATH, siteOrigin).href}
    >
      確認メールが届いてない場合
    </CowcamoTextLink>
  );
};

export default CowcamoConfirmationResendLink;
